import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-details-accordion-material-and-care" }
const _hoisted_2 = { class: "product-details-accordion-material-and-care__card" }
const _hoisted_3 = { class: "product-details-accordion-material-and-care__card-title" }
const _hoisted_4 = { class: "product-details-accordion-material-and-care__card-content" }
const _hoisted_5 = { class: "product-details-accordion-material-and-care__card-list" }
const _hoisted_6 = { class: "product-details-accordion-material-and-care__list-item-title" }
const _hoisted_7 = { class: "product-details-accordion-material-and-care__material-composition" }
const _hoisted_8 = {
  key: 0,
  class: "product-details-accordion-material-and-care__list-item-extra-info"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "product-details-accordion-material-and-care__card" }
const _hoisted_12 = { class: "product-details-accordion-material-and-care__card-title" }
const _hoisted_13 = { class: "product-details-accordion-material-and-care__card-content" }
const _hoisted_14 = { class: "product-details-accordion-material-and-care__card-content-images" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "product-details-accordion-material-and-care__card-content-text" }
const _hoisted_17 = ["innerHTML"]

import { computed, inject } from 'vue';

import { toLitiumMediaUrlKey } from '@distancify/drapejs-litium/lib/keys';

import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailsAccordionMaterialAndCare',
  setup(__props) {

const { websiteText } = useWebsiteTexts();

const pdpDetails = inject('pdpDetails') as any;
const toLitiumMediaUrl = inject(toLitiumMediaUrlKey) as any;

const features = computed(() => {
  return pdpDetails.value?.materials?.features || [];
});

const descriptions = computed(() => {
  const allDescriptions = features.value.flatMap((feature) => feature.descriptions);
  return Array.from(new Set(allDescriptions));
});

const materialDescription = computed(
  () => websiteText('productdetails_materialstext').value
);

const careGuide = computed(() => pdpDetails.value?.careGuide);

const washInstructions = computed(() => careGuide.value?.washInstructions);

const washDescription = computed(
  () => websiteText('productdetails_careguidetext').value
);

const breathable = computed(() => pdpDetails.value?.breathableLevel);

const dry = computed(() => pdpDetails.value?.dryLevel);

function getExtraInfo(feature) {
  let info = '';

  if (feature.value.toLowerCase().includes('padding')) {
    info = breathable.value;
  }

  if (feature.value.toLowerCase().includes('shell')) {
    info = dry.value;
  }

  return info;
}

function getImageUrl(imageId) {
  return toLitiumMediaUrl(imageId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(websiteText)('productdetails_materialstab').value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(features), (feature) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "product-details-accordion-material-and-care__list-item",
              key: feature
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(feature.title) + ": ", 1),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feature.materialComposition, (composition) => {
                  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(composition), 1))
                }), 256))
              ]),
              _createElementVNode("div", null, [
                (!!getExtraInfo(feature))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(getExtraInfo(feature)), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(descriptions), (description) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "product-details-accordion-material-and-care__card-description",
          innerHTML: description
        }, null, 8, _hoisted_9))
      }), 256)),
      _createElementVNode("div", {
        class: "product-details-accordion-material-and-care__card-description",
        innerHTML: _unref(materialDescription)
      }, null, 8, _hoisted_10)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(websiteText)('productdetails_careguidetab').value), 1),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(washInstructions), (washInstruction) => {
            return (_openBlock(), _createElementBlock("div", {
              key: washInstruction.text,
              class: "product-details-accordion-material-and-care__card-content-wrapper"
            }, [
              _createElementVNode("img", {
                class: "product-details-accordion-material-and-care__card-content-image",
                src: getImageUrl(washInstruction.imageId),
                alt: "Wash instruction"
              }, null, 8, _hoisted_15),
              _createElementVNode("div", _hoisted_16, _toDisplayString(washInstruction.text), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", {
        class: "product-details-accordion-material-and-care__card-description",
        innerHTML: _unref(washDescription)
      }, null, 8, _hoisted_17)
    ])
  ]))
}
}

})